// extracted by mini-css-extract-plugin
export default {"alertPosition":"InstallPWA_alertPosition__uS3Wn"};